export default "__VITE_ASSET__25fdc01e__"